import MuiAlert, { type AlertProps } from '@mui/material/Alert';

export type { AlertProps };

const Alert = (props: AlertProps) => <MuiAlert {...props} />;

export default Alert;
